import client from './config';

// Feature Limits API Service
export const featureLimitsAPI = {
  // Check if user can perform action
  checkFeatureAccess: async (userId, featureName, timezone = null, checkDate = null) => {
    try {
      // Auto-detect timezone if not provided
      const userTimezone = timezone || Intl.DateTimeFormat().resolvedOptions().timeZone;
      
      const requestBody = {
        userId,
        featureName,
        timezone: userTimezone
      };
      
      // Only include checkDate if provided (for future date limit checks)
      if (checkDate) {
        requestBody.checkDate = checkDate;
      }
      
      const response = await client.post('/api/check-feature-access', requestBody);
      return response.data;
    } catch (error) {
      console.error('Error checking feature access:', error);
      throw error;
    }
  },

  // Log feature usage
  logFeatureUsage: async (userId, featureName, usageCount = 1, metadata = null, timezone = null) => {
    try {
      // Auto-detect timezone if not provided
      const userTimezone = timezone || Intl.DateTimeFormat().resolvedOptions().timeZone;
      
      const response = await client.post('/api/log-feature-usage', {
        userId,
        featureName,
        usageCount,
        metadata: metadata || null,
        timezone: userTimezone
      });
      return response.data;
    } catch (error) {
      console.error('Error logging feature usage:', error);
      throw error;
    }
  },

  // Get user limits for dashboard
  getUserLimits: async (userId, timezone = null) => {
    try {
      // Auto-detect timezone if not provided
      const userTimezone = timezone || Intl.DateTimeFormat().resolvedOptions().timeZone;
      
      const response = await client.get(`/api/user-limits/${userId}`, {
        params: {
          timezone: userTimezone
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching user limits:', error);
      throw error;
    }
  },

  // Get user subscription status
  getSubscriptionStatus: async (userId) => {
    try {
      const response = await client.get(`/api/subscription-status/${userId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching subscription status:', error);
      throw error;
    }
  },

  // Get referral code
  getReferralCode: async (userId) => {
    try {
      const response = await client.get(`/api/referral-code/${userId}`);
      return response.data;
    } catch (error) {
      console.error('Error getting referral code:', error);
      throw error;
    }
  },

  // Process referral signup
  processReferral: async (inviterUserId, inviteeUserId, referralCode) => {
    try {
      const response = await client.post('/api/process-referral', {
        inviterUserId,
        inviteeUserId,
        referralCode
      });
      return response.data;
    } catch (error) {
      console.error('Error processing referral:', error);
      throw error;
    }
  },

  // Get user credits
  getUserCredits: async (userId) => {
    try {
      const response = await client.get(`/api/user-credits/${userId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching user credits:', error);
      throw error;
    }
  },

  // Get referral statistics
  getReferralStats: async (userId) => {
    try {
      const response = await client.get(`/api/referral-stats/${userId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching referral stats:', error);
      throw error;
    }
  }
};

// Feature names constants
export const FEATURE_NAMES = {
  KNACK_MOMENTS: 'knack_moments',
  KNACK_FEEDS: 'knack_feeds',
  MANUAL_POSTS: 'manual_posts',
  POLLS: 'polls',
  SCHEDULE_DAYS: 'schedule_days',
  CHALLENGES: 'challenges'
};

// Feature display names
export const FEATURE_DISPLAY_NAMES = {
  [FEATURE_NAMES.KNACK_MOMENTS]: 'Knack Moments',
  [FEATURE_NAMES.KNACK_FEEDS]: 'Knack Feeds',
  [FEATURE_NAMES.MANUAL_POSTS]: 'Create Posts',
  [FEATURE_NAMES.POLLS]: 'Polls',
  [FEATURE_NAMES.SCHEDULE_DAYS]: 'Post Schedules',
  [FEATURE_NAMES.CHALLENGES]: 'Knack Challenges'
};

// Subscription types
export const SUBSCRIPTION_TYPES = {
  FREE: 'free',
  MONTHLY: 'monthly',
  ANNUALLY: 'annually'
};

// Subscription display names
export const SUBSCRIPTION_DISPLAY_NAMES = {
  [SUBSCRIPTION_TYPES.FREE]: 'Free',
  [SUBSCRIPTION_TYPES.MONTHLY]: 'Monthly',
  [SUBSCRIPTION_TYPES.ANNUALLY]: 'Annual'
};
